import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { DepositSuccess, DepositCancel, DepositError, Loader, PageLayout } from "src/components";
import { ERoutes, EDepositStatus } from "src/types";
import { isNestedIframe } from "src/utils";
import { useSendDepositStatusRedirect } from "src/hooks";

const DepositStatus: React.FC = (): JSX.Element => {
  const { status } = useParams<{ status: EDepositStatus }>();

  useSendDepositStatusRedirect(status);

  // If we're in a nested iframe, show a loading state
  // The parent will handle the actual navigation
  if (isNestedIframe()) {
    return <Loader />;
  }

  const renderContent = () => {
    switch (status) {
      case EDepositStatus.Success:
        return <DepositSuccess />;
      case EDepositStatus.Cancel:
        return <DepositCancel />;
      case EDepositStatus.Error:
        return <DepositError />;
      default:
        return <Navigate to={ERoutes.NotFound} replace />;
    }
  };

  return (
    <PageLayout centered>
      {renderContent()}
    </PageLayout>
  );
};

export default DepositStatus;
